import { useMediaQuery } from '@mui/material';
import { createTheme, useTheme } from '@mui/material/styles';

export const theme = createTheme({
	typography: {
		fontFamily: ['Segoe UI', 'Arial', 'sans-serif'].join(','),
		button: {
			textTransform: 'none',
			fontWeight: 600,
		},
	},
	palette: {
		primary: {
			main: '#00A884',
			dark: '#008069',
		},
		text: {
			primary: '#111B21',
			secondary: '#667781',
		},
		background: {
			default: '#F0F2F5',
			paper: '#FFFFFF',
		},
	},
	shape: {
		borderRadius: 6,
	},
	components: {
		MuiButtonBase: {
			defaultProps: {
				disableRipple: true,
			},
		},
		MuiCircularProgress: {
			styleOverrides: {
				root: {
					color: '#00A884',
				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				root: {
					borderColor: '#E9EDEF',
				},
			},
		},
		MuiTablePagination: {
			styleOverrides: {
				root: {
					color: '#667781',
					backgroundColor: '#FFFFFF',
					borderTop: '1px solid #E9EDEF',
				},
			},
		},
	},
});

export function useMainCustomStyle() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	if (isMobile) {
		return {
			paddingTop: '60px',
			height: '100vh',
			boxSizing: 'border-box' as const,
		};
	} else {
		return {
			paddingLeft: '216px',
			paddingTop: '60px',
			height: '100vh',
			boxSizing: 'border-box' as const,
		};
	}
}

export const helperText = {
	fontSize: '12px',
	color: 'red',
	paddingBottom: '5px',
	paddingLeft: '10px',
};

export const FileUploadDiv = {
	border: '1px dashed #D9D9D9',
	backgroundColor: '#FFFFFF',
	borderRadius: '5px',
	padding: '50px',
	textAlign: 'center',
	marginBottom: '10px',
};

export const DialogBackground = {
	backgroundColor: 'rgba(0,0,0,0.74)',
};

export const DialogTitleStyle = {
	fontWeight: '600',
	display: 'flex',
	justifyContent: 'space-between',
	boxShadow: '0px 3px 14px -1px rgba(0, 0, 0, 0.08)',
	marginBottom: '24px',
};
